import React from 'react';
import PropTypes from 'prop-types';

export const Option = ({children, disabled, cy}) => {
	const textColor = disabled && '#a1a1a1';

	return (
		<div color={textColor} data-cy={cy} title={children}>
			{children}
		</div>
	);
};

Option.propTypes = {
	children: PropTypes.any,
	value: PropTypes.any,
	disabled: PropTypes.bool,
	cy: PropTypes.string,
};
